<template>
    <div v-if="enabled" class="belme_view">
        <div class="clear"></div>
        <div class="cruise-stappen border2 stap1 width100 margintop20">
            <div class="stap-header">
                <div
                    class="fontsize14 bold midblauw padding10 uppercase lichtblauwbg"
                >
                    Bel me terug
                </div>
                <div class="clear"></div>
                <div class="stap-content overflowhidden padding10">
                    <div>
                        <span
                            class="label width32 bold lineheight30 belme_input"
                            >Naam</span
                        >
                        <input
                            v-model="name"
                            class="height30 width40 belme_naam belme_input"
                            placeholder="Naam"
                            type="text"
                        />
                    </div>

                    <div class="floatleft height5 width100"></div>
                    <div>
                        <span
                            class="label width32 bold lineheight30 belme_input"
                            >Nummer</span
                        >
                        <input
                            v-model="number"
                            class="height30 width40 belme_nummer belme_input"
                            placeholder="Nummer"
                            type="text"
                        />
                    </div>
                    <div class="clear paddingtop10 belme_input"></div>
                    <div class="belme_msg"></div>
                    {{ message }}
                    <button
                        v-if="!success"
                        v-on:click="doBelMeRequest"
                        class="button groenbg smallbutton font11 rounded width100 submit_belme_aanvragen belme_input"
                    >
                        Bel me terug&nbsp;&nbsp;&nbsp;
                        <font-awesome-icon icon="phone" />
                    </button>
                </div>
            </div>
        </div>
        <div class="clear"></div>
    </div>
</template>

<script>
export default {
    name: 'BelMe',
    data: function() {
        return {
            number: null,
            name: null,
        }
    },
    methods: {
        doBelMeRequest: function() {
            this.$store.dispatch('saveBelMeRequest', {
                number: this.number,
                name: this.name,
            })
        },
    },
    computed: {
        success: function() {
            return this.$store.state.belMeData.success
        },
        message: function() {
            return this.$store.state.belMeData.message
        },
        enabled: function() {
            return (
                this.$store.state.belMeConfig &&
                this.$store.state.belMeConfig.enabled &&
                this.$store.getters.currentlyOpen
            )
        },
    },
}
</script>

<style scoped></style>
